/**
 * PHONE WIDTH (≤640px). Every phone-only layout in the CRM keys off this one
 * breakpoint, so desktop is untouched by any of them. The matching CSS rules
 * (16px inputs, 44px targets) live in index.html under the same media query.
 */

import { useEffect, useState } from 'react';

export const PHONE_QUERY = '(max-width: 640px)';

export function usePhoneWidth(): boolean {
  const [phone, setPhone] = useState(() => { try { return window.matchMedia(PHONE_QUERY).matches; } catch { return false; } });
  useEffect(() => {
    let mq: MediaQueryList;
    try { mq = window.matchMedia(PHONE_QUERY); } catch { return; }
    const on = () => setPhone(mq.matches);
    on();
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  return phone;
}
